var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1439 70.0174H64.287C65.651 70.0174 66.9592 69.4822 67.9237 68.5296C68.8882 67.577 69.4301 66.2849 69.4301 64.9378C69.4301 63.5906 68.8882 62.2985 67.9237 61.3459C66.9592 60.3933 65.651 59.8582 64.287 59.8582H56.5724C55.0294 59.8582 53.7437 60.3661 52.9722 61.382L38.5715 75.097",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8578 85.2562L52.9723 81.7005C53.7437 80.6845 55.0295 80.1766 56.5724 80.1766H66.8586C69.6873 80.1766 72.2589 79.1607 74.059 77.1288L85.8881 65.9537C86.8804 65.0275 87.4596 63.7499 87.4982 62.402C87.5367 61.054 87.0316 59.7461 86.0938 58.7661C85.156 57.786 83.8625 57.214 82.4977 57.1759C81.1329 57.1378 79.8087 57.6367 78.8163 58.5629L68.0158 68.4681",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72.5571L51.4293 87.7959",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0016 62.1439C76.1202 62.1439 79.459 58.8463 79.459 54.7785C79.459 50.7107 76.1202 47.4131 72.0016 47.4131C67.8829 47.4131 64.5441 50.7107 64.5441 54.7785C64.5441 58.8463 67.8829 62.1439 72.0016 62.1439Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2862 52.2388C50.5469 52.2388 54.0008 48.8275 54.0008 44.6194C54.0008 40.4113 50.5469 37 46.2862 37C42.0255 37 38.5715 40.4113 38.5715 44.6194C38.5715 48.8275 42.0255 52.2388 46.2862 52.2388Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs14);
export default __webpack_public_path__ + "static/media/IconFaqs14.7a5c6a6ebcdfc103b7bed8a233747036.svg";
export { ForwardRef as ReactComponent };